import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setForm((s) => ({ ...s, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(form);
      toast.success("Account created");
      navigate("/dashboard");
    } catch (err) { toast.error(apiError(err)); }
    finally { setBusy(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-sidebar p-6">
      <div className="w-full max-w-sm rounded-sm border border-white/10 bg-card p-8">
        <img src="/icons/icon-96.png" alt="" className="mb-3 h-12 w-12 rounded-sm" />
        <span className="eyebrow">Get started</span>
        <h2 className="mt-1 font-display text-3xl font-bold tracking-tight">Create account</h2>
        <p className="mt-2 text-sm text-muted-foreground">New sign-ups start as Staff. An admin can elevate your role.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div className="space-y-1.5">
            <Label className="eyebrow">Full name</Label>
            <Input data-testid="reg-name" value={form.name} onChange={(e) => set("name", e.target.value)} required />
          </div>
          <div className="space-y-1.5">
            <Label className="eyebrow">Email</Label>
            <Input data-testid="reg-email" type="email" value={form.email} onChange={(e) => set("email", e.target.value)} required />
          </div>
          <div className="space-y-1.5">
            <Label className="eyebrow">Password</Label>
            <Input data-testid="reg-password" type="password" value={form.password} onChange={(e) => set("password", e.target.value)} required />
          </div>
          <Button type="submit" className="w-full" disabled={busy} data-testid="reg-submit">{busy ? "Creating…" : "Create account"}</Button>
        </form>
        <p className="mt-6 text-center text-sm text-muted-foreground">
          Already have an account? <Link to="/login" className="font-medium text-primary hover:underline">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
